import { RESOURCE_MANAGER_BASE_URL, MAPPED_CHANNELS_URL } from "plugin-quantitative-ruled-channel-dra-engine/utils/constants"
import { requestCommon } from 'live/lib/utils'



export const listMappedChannels = async (assetId: number): Promise<IMappedChannels> => {
  // const qs = new URLSearchParams({}).toString()
  return fetch(`${RESOURCE_MANAGER_BASE_URL}/${MAPPED_CHANNELS_URL}/${assetId}`, {
      ...requestCommon,
      method: 'GET'
  }).then(async data => {
      let jsonData

      try {
          jsonData = await data.json()
      } catch (err) {
          jsonData = undefined
      }

      if (data.ok) {
          return jsonData
      } else {
          throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message)
      }
  })
}